const Host = "https://api.patliputraanokhihomes.com"
// const Host = "http://localhost:8000"
// const Host = "https://api.anokhihomes.net"
export default Host;